// @ts-nocheck
import Button from "@app/components/move2Library/Button/Button"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import { useGetStrings } from "@app/store/service/cmsService"
import { appStore } from "@app/store/store"
import { ORDER_LINE_TYPES } from "@app/utils/constants"
import { Modal, useModal } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { useEffect, useState } from "react"
import "./MassageReservationExpiredModal.css"

export const MassageReservationExpiredModal = ({ scanCode }) => {
	const shoppingCart = useSelector(state => state.order.shoppingCart)
	const [scanCodeLink] = useState(scanCode)

	const { hideModal } = useModal()
	const { push } = useCustomNavigation()
	const {
		data: { massageReservationExpiredModalTitle, massageReservationExpiredModalText, massageReservationExpiredBookingButton },
	} = useGetStrings(undefined, { defaultData: {} })

	const StartNewBooking = () => {
		scanCodeLink != undefined ? push(`massage?ticketNumber=${scanCodeLink}`) : push("massage")
		hideModal()
	}

	useEffect(() => {
		const nextShoppingCart = [...shoppingCart]
		//We want to remove all massages after time ran out
		appStore.set("order.massages", [])
		//We want to keep everything in the cart what is no massage
		const next = nextShoppingCart.filter(e => {
			if (e.typeId !== ORDER_LINE_TYPES.Activity) return true
		})
		appStore.set("order.shoppingCart", next)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<Modal className="massageReservationExpiredModal">
			<Modal.Closer onClick={hideModal} />
			<Modal.Header>{massageReservationExpiredModalTitle}</Modal.Header>
			<Modal.Body>{massageReservationExpiredModalText}</Modal.Body>
			<Modal.Footer className="massageReservationExpiredModal__footer">
				<div className="flex flex-center">
					<Button className="booking__button" id="booking__button" style="primary" onClick={StartNewBooking}>
						{massageReservationExpiredBookingButton}
					</Button>
				</div>
			</Modal.Footer>
		</Modal>
	)
}
